import { OktaAuth } from '@okta/okta-auth-js'
import {throttle} from 'lodash'
import sessionService from "@services/session.service";
import authService from "@services/auth.service";
import {appInsights} from "../appInsights";

export function createOktaInstance (client: any) {
  const oktaInstance = new OktaAuth(
    {
      clientId: client?.clientId || "",
      issuer: client?.authority || "",
      redirectUri: '/auth/sso-redirect',
      scopes: ['openid', 'profile', 'email']
    }
  )
  return oktaInstance
}

export function createOktaSessionCheck(client: any) {
  let instance = createOktaInstance(client)
  const sessionCheck = throttle(
    () => {
      instance.session.get()
        .then(
          (response: any) => {
            const user = sessionService.user
            if (response?.status !== 'ACTIVE') {
              authService.logout().subscribe({
                next: ()=>{
                  sessionService.logout();
                  appInsights.clearAuthenticatedUserContext();
                },
                error: ()=>{
                }
              })
            }
          }
        ).catch(
          () => {
            authService.logout().subscribe({
              next: ()=>{
                sessionService.logout();
                appInsights.clearAuthenticatedUserContext();
              },
              error: ()=>{
              }
            })
          }
        )
    },
    5000,
    {
      leading: true,
      trailing: false
    }
  )

  return sessionCheck
}
